import React, { useEffect, useState } from 'react'
import ApiCalls from '../ApiCalls';
import IntlMessages from '../../helpers/IntlMessages';
import { Button } from 'react-bootstrap';
import Spinner from '../Spinner';

export default function SessionsDescriptionOnline({ activity }) {
  const { id } = activity;
  const [isLoading, setIsLoading] = useState(false);
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (isLoading && !description) {
      ApiCalls.getActivityDescription(activity)
        .then(description => {
          setDescription(description.data.description);
        })
        .finally(() => setIsLoading(false));
    }
  }, [activity, description, id, isLoading])

  if (isLoading) {
    return <div className='description-online-container'><Spinner hideText /></div>;
  }

  return (
    <div className='description-online-container'>
      {
        !isLoading && !description && <Button
          onClick={() => setIsLoading(true)}
          variant="secondary"
          className='description-online-button'
        >
          <IntlMessages id="dashboards.description-online" />
          <i className="simple-icon-arrow-down" />
        </Button>
      }
      {
        description &&
        <div
          dangerouslySetInnerHTML={{
            __html: description
          }}
          className="description-online-modal"
        />
      }
    </div>
  )
}
